import * as React from "react";

export type DropdownContextType = {
  // classNames: string[]
  addChildren: (className: string) => any,
  removeChildren: (className: string) => any,
};

export const DropdownContext = React.createContext<DropdownContextType>(null);
